<template>
  <div>
    <template v-if="isFullScreen">
      <CardTarjaTVZFullScreen
        :item="item"
        :hideUserInfo="hideUserInfo"
        :flgExibirUf="flgExibirUf"
      />
    </template>
    <template v-else>
      <CardTarjaTVZComments
        :item="item"
        :posicao-card="posicaoCard"
        :hide-user-info="hideUserInfo"
        :flg-exibir-uf="flgExibirUf"
      />
    </template>
  </div>
</template>

<script>
import CardTarjaTVZFullScreen from "./CardTarjaTVZFullScreen.vue";
import CardTarjaTVZComments from "./CardTarjaTVZComments.vue";

export default {
  props: {
    item: Object,
    isFullScreen: Boolean,
    posicaoCard: String,
    hideUserInfo: Boolean,
    flgExibirUf: Boolean,
  },
  components: {
    CardTarjaTVZFullScreen,
    CardTarjaTVZComments,
  },
};
</script>
